/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Moment_FeatureInputs */

const en_directory_comparison_product_hunt_rows_moment_feature = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Moment_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary moment`)
};

const zh_directory_comparison_product_hunt_rows_moment_feature = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Moment_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要时刻`)
};

/**
* | output |
* | --- |
* | "Primary moment" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Moment_FeatureInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_moment_feature = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Moment_FeatureInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Moment_FeatureInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_moment_feature(inputs)
	return zh_directory_comparison_product_hunt_rows_moment_feature(inputs)
});
export { directory_comparison_product_hunt_rows_moment_feature as "directory.comparison.product_hunt.rows.moment.feature" }